<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light fixed-top" style="max-height: 72px;">
      <div
        class="container"
        style="max-width: 1185px !important; margin-top: 5px"
      >
        <a class="navbar-brand" href="/">
          <img
            class="img-fluid d-block"
            :src="logoPath"
            :style="this.largura < 500 ? 'width: 35%' : 'width: 10%'"
          />
        </a>
        <!-- <button
          class="navbar-toggler navbar-toggler-right border-0"
          type="button"
          data-toggle="collapse"
          data-target="#navbar5"
        >
          <span class="navbar-toggler-icon"></span>
        </button> -->
        <ul class="navbar-nav ml-auto text-center"></ul>
      </div>
    </nav>

    <router-view></router-view>

    <div class="footer1" style="">
      <div class="container">
        <div class="row align-items-center pt-4">
          <div class="row col justify-content-around">
            <div>
              <h5><b>Tricard</b></h5>
              <ul class="list-unstyled">
                <li><a href="/" style="color: #1641cc">Home</a></li>
                <router-link
                  v-for="link in footerlinksc"
                  :key="link.text"
                  :to="{}"
                  @click.native="redirectPolitica(link, 'tricard')"
                >
                  <li>
                    <a target="_blank" style="color: #1641cc"
                      >{{ link.text }}
                    </a>
                  </li>
                </router-link>
              </ul>
            </div>
            <div>
              <h5><b>Tribanco</b></h5>
              <ul class="list-unstyled">
                <li><a href="/" style="color: #1641cc">Home</a></li>
                <router-link
                  v-for="link in footerlinks"
                  :key="link.text"
                  :to="{}"
                  @click.native="redirectPolitica(link, 'tribanco')"
                >
                  <li>
                    <a target="_blank" style="color: #1641cc"
                      >{{ link.text }}
                    </a>
                  </li>
                </router-link>
              </ul>
            </div>
          </div>
          <div class="row col justify-content-center">
            <div>
              <p class="mb-0">Tricard | Fale conosco:</p>
              <a
                @click="saveLogcontatoPhone((ownerAlias = 'Tricard'))"
                class="btn btn-link"
                href="tel:+5508007223099"
                ><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 722 3099</a
              ><a
                @click="openWhats((ownerAlias = 'Tricard'))"
                class="btn btn-link"
                href="https://api.whatsapp.com/send?l=pt&amp;phone=551130033099"
                target="_blank"
                ><i class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(11)
                3003-3099</a
              >
              <hr />
            </div>
            <div>
              <p class="mb-0">Tribanco | Fale conosco:</p>
              <a
                @click="saveLogcontatoPhone((ownerAlias = 'Tribanco'))"
                class="btn btn-link"
                href="tel:+5508009793355"
                ><i class="fa fa-phone fa-fw mx-1 fa-lg"></i>0800 979 3355</a
              ><a
                @click="openWhats((ownerAlias = 'Tribanco'))"
                class="btn btn-link"
                href="https://api.whatsapp.com/send?l=pt&amp;phone=553430033366"
                target="_blank"
                ><i class="fa fa-whatsapp fa-fw mx-1 fa-lg"></i>(34)
                3003-3366</a
              >
              <hr />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <p class="mb-1">@tribanco | tricard</p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="nav">
      <a class="nav-link wts bg-success" @click="openWhats()" target="_blank" style="cursor:pointer">
        <i class="fa fa-2x fa-whatsapp text-light"></i>
      </a>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ActionGetIPAddress } from "@/utils/helpers";

export default {
  name: "Landing",
  components: {},
  data: () => ({
    authlinks: [{ icon: "", text: "Início", route: "/dashboard" }],
    hrefwhatsapp: "https://api.whatsapp.com/send?l=pt&phone=551132303765",
    footerlinks: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tribanco",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    footerlinksc: [
      { icon: "", text: "Quem Somos", route: "somos" },
      {
        icon: "",
        text: "Termos de uso",
        route: "termos_tricard",
        params: "Termos de uso",
      },
      {
        icon: "",
        text: "Política de privacidade",
        route:
          "https://www.tribanco.com.br/seg-corporativa/politica-de-privacidade/",
        params: "Política de privacidade",
      },
    ],
    largura: null,
    ipUser: null
  }),
  methods: {
    ...mapActions("auth", [
      "ActionDoLogout",
      "ActionMenuLinks",
      "ActionGetUser",
      "ActionGetWhatsText",
      "ActionSendAccessLogWithoutToken",
      "ActionLogContato",
    ]),
    // ...mapActions('meusBoletos', ['ActionSendAccessLogWithoutToken']),

    async saveLogcontatoPhone(ownerAlias) {
      this.ActionLogContato({
        DocNumber: null,
        tag: "Padrao",
        ownerAlias: ownerAlias,
        contactType: "Telefone",
        IP: this.ipUser ? this.ipUser : "",
      });
    },

    async openWhats(ownerAlias) {
      if (this.user != null) {
        var whats = await this.ActionGetWhatsText({ OS: navigator.platform });
        this.hrefwhatsapp = this.hrefwhatsapp + "&text=" + whats[0];
      }
      // else{
      //   console.log('registrando log...');
      //    await this.ActionSendAccessLogWithoutToken({
      //     ValueId : 16
      //   });
      //   this.hrefwhatsapp = this.hrefwhatsapp + '&text=Olá, não encontrei meus dados podem me ajudar ?';

      //   console.log('log registrado.');
      // }

      //  window.open(this.hrefwhatsapp, "_blank");

      this.ActionLogContato({
        DocNumber: null,
        tag: "Padrao",
        ownerAlias: ownerAlias,
        contactType: "WhatsApp",
        IP: this.ipUser ? this.ipUser : "",
      });
    },

    redirectPolitica(link, banco) {
      if (link.route.includes("https://")) {
        window.open(link.route, "_blank").focus();
      } else {
        this.$router.push({
          name: link.route,
          query: { title: link.text, banco },
        });
      }
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          console.log("this.ipUser: " + JSON.stringify(this.ipUser));
          break; // Saia do loop se o IP for obtido com sucesso
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000)); // Aguarde 1 segundo antes de tentar novamente
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },
  async created() {
    await this.getIPAddressUser();
    this.largura = window.screen.width;
    if (this.user != null) {
      await this.ActionGetUser();
      this.user.Menus.forEach((menuId) => {
        switch (parseInt(menuId)) {
          case 2:
            this.authlinks.push({
              icon: "",
              text: "Contratos Negociáveis",
              route: "/dashboard/minhas-dividas",
            });
            break;
          case 1:
            this.authlinks.push({
              icon: "",
              text: "Boletos Ativos",
              route: "/dashboard/meus-boletos",
            });
            break;
          case 3:
            this.authlinks.push({
              icon: "",
              text: "Acordos",
              route: "/dashboard/meus-acordos",
            });
            break;
        }
      });
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    envOwnerId() {
      // Lê diretamente do process.env para garantir que está atualizado
      const ownerId = process.env.VUE_APP_OWNER_ID;
      console.log("envOwnerId raw:", ownerId, "type:", typeof ownerId);
      
      // Se for string, tenta fazer parse
      if (typeof ownerId === 'string') {
        try {
          // Tenta parsear como JSON (caso seja array como string)
          const parsed = JSON.parse(ownerId);
          return Array.isArray(parsed) ? parsed : [Number(parsed)];
        } catch {
          // Se não for JSON, tenta converter para número
          const num = Number(ownerId);
          return isNaN(num) ? null : num;
        }
      }
      
      // Se já for array ou número, retorna como está
      return ownerId;
    },
    isTricard() {
      const ownerId = this.envOwnerId;
      console.log("isTricard - ownerId:", ownerId);
      
      if (!ownerId) return false;
      
      if (Array.isArray(ownerId)) {
        return ownerId.some((id) => [10, 25].includes(Number(id)));
      }
      
      return [8, 22].includes(Number(ownerId));
    },
    logoPath() {
      const path = this.isTricard ? '/img/logo-tricard.png' : '/img/logo-tribanco.png';
      console.log("logoPath - isTricard:", this.isTricard, "path:", path);
      return path;
    },
  },
};
</script>
